import BaseService from "../../../../../service/BaseService";

class UstoreModuleService extends BaseService {

  static NAME = 'UstoreModuleService';

}

export default UstoreModuleService;
